import { FrameAction } from '@aipb/frame/model';

import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'fr-sidebar-action-menu',
  templateUrl: './sidebar-action-menu.component.html',
  styleUrls: ['./sidebar-action-menu.component.scss'],
  exportAs: 'actionMenu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMenuModule, MatIconModule, MatDividerModule, TranslocoModule]
})
export class SidebarActionMenuComponent {
  @Input() actions: FrameAction[] = [];

  // @ts-expect-error foo
  @ViewChild(MatMenu, { static: true }) menu: MatMenu;
}
